import MobileMainRailCondensedMcom from './MobileMainRailCondensed.mcom';
import MobileMainRailCondensedBcom from './MobileMainRailCondensed.bcom';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? MobileMainRailCondensedBcom : MobileMainRailCondensedMcom;
